// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3":"27790593c96eeef2","101":"d061e0ed4fa3e1b9","659":"7a44bbf5939f5eff"}[chunkId] + ".js";
};